import { render, staticRenderFns } from "./ScheduleRule.vue?vue&type=template&id=0b24b702&scoped=true"
import script from "./ScheduleRule.vue?vue&type=script&lang=js"
export * from "./ScheduleRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b24b702",
  null
  
)

export default component.exports